import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
import { Routes, RouterModule } from '@angular/router';

import { ReportsComponent } from './reports.component';
import { LimitsComponent } from '../limits/limits.component';
import { CompareComponent } from '../compare/compare.component';
import { ReviewComponent } from '../review/review.component';
import { AuthGuard } from '../common/auth.guard';

const REPORTSROUTES: Routes = [
    {
        path: 'reports', component: ReportsComponent,
        children: [
            { path: 'limits', component: LimitsComponent, canActivate: [AuthGuard] },
            { path: 'compare', component: CompareComponent },
            { path: 'review', component: ReviewComponent, canActivate: [AuthGuard] }
        ]
    }
];

export const REPORTSROUTING: ModuleWithProviders = RouterModule.forChild(REPORTSROUTES);



// WEBPACK FOOTER //
// ./src/app/reports/reports.routing.ts